import { get } from '../iterable/get';

export function getLowestId(lowest, item) {
  const id = get('id')(item);
  return Number.isFinite(id)
    ? Math.min(lowest, id)
    : lowest;
}
